// ============================================================================
// TeamIdentityCard — carte identite employee (E1b DEFERES, F-204/205, M-201)
// ============================================================================
// Port fidele du PoC page.tsx TeamIdentityCard @ 7e40e4a : logo/nom/departement,
// directeur, membres — NON cliquable (detail /equipes/:id reserve a la gestion).
// Pas de pulse / objectifs / distinctions / matricule (matrice PII : pas
// d'elargissement). Regle #4 : zero emoji.

import { GsAvatar, GS_COMPONENTS } from '@gs/ui';
import { useTranslation } from '../../i18n';
import type { TeamIdentityCard as TeamIdentityCardDto } from '../../hooks/useTeams';

const STACK_MAX = 4;

export function TeamIdentityCard({ team }: { team: TeamIdentityCardDto }) {
  const { t } = useTranslation();
  const visible = team.members.slice(0, STACK_MAX);
  const overflow = Math.max(0, team.members.length - STACK_MAX);

  return (
    <div className={`${GS_COMPONENTS.card} flex flex-col gap-3 p-4`}>
      <header className="flex items-start justify-between gap-3">
        <div className="flex min-w-0 items-center gap-3">
          {/* Logo stream = management-gated (/logo/content) : initiales pour
              la vue employee (M-201) — pas d'elargissement de garde logo. */}
          <span
            className="flex h-9 w-9 shrink-0 items-center justify-center rounded-lg bg-slate-100 text-xs font-semibold text-slate-600 dark:bg-slate-700 dark:text-slate-300"
            aria-hidden="true"
          >
            {team.name.slice(0, 2).toUpperCase()}
          </span>
          <div className="min-w-0">
            <h3 className="truncate text-base font-semibold tracking-tight text-slate-900 dark:text-slate-100">
              {team.name}
            </h3>
            <p className="truncate text-xs text-slate-500 dark:text-slate-400">
              {team.department ?? t('gest:equipes.header.headcount', { n: team.headcount })}
            </p>
          </div>
        </div>
      </header>

      <div className="flex items-center justify-between gap-3">
        {team.directorEmail ? (
          <div className="flex min-w-0 items-center gap-2">
            <GsAvatar
              name={team.directorName ?? team.directorEmail}
              size="sm"
            />
            <p className="truncate text-xs text-slate-500 dark:text-slate-400">
              {team.directorName ?? team.directorEmail}
            </p>
          </div>
        ) : (
          <p className="text-xs text-slate-500 dark:text-slate-400">
            {t('gest:equipes.identity.noDirector')}
          </p>
        )}
        {visible.length > 0 ? (
          <div className="flex shrink-0 items-center -space-x-2">
            {visible.map((m) => (
              <GsAvatar
                key={m.email}
                name={m.fullName ?? m.email}
                size="sm"
                className="ring-2 ring-white dark:ring-slate-900"
              />
            ))}
            {overflow > 0 ? (
              <span className="flex h-8 w-8 items-center justify-center rounded-full bg-slate-100 text-xs font-medium text-slate-600 ring-2 ring-white dark:bg-slate-700 dark:text-slate-300 dark:ring-slate-900">
                +{overflow}
              </span>
            ) : null}
          </div>
        ) : (
          <span className="shrink-0 text-xs text-slate-500 dark:text-slate-400">
            {t('gest:equipes.header.headcount', { n: team.headcount })}
          </span>
        )}
      </div>
    </div>
  );
}
